import LeadingLink from './LeadingLink'

export default LeadingLink
